import {FC, ReactNode} from 'react'

const MINT = {background: '#E6F4EA', color: '#1F7A3E'}
const NEUTRAL = {background: '#fff', color: '#374151', border: '1.5px solid #E5E7EB'}

const TILE: Record<string, {background: string; color?: string; border?: string}> = {
  PHONE: MINT,
  EMAIL: MINT,
  WEBSITE: NEUTRAL,
  WHATSAPP: {background: '#25D366'},
  LINE: {background: '#06C755'},
  INSTAGRAM: {background: 'linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)'},
  MESSENGER: {background: 'linear-gradient(135deg,#00B2FF,#006AFF)'},
  TELEGRAM: {background: '#229ED9'},
  FACEBOOK: {background: '#1877F2'},
  TIKTOK: {background: '#111111'},
}

const stroke = {fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round'} as const

const GLYPHS: Record<string, ReactNode> = {
  PHONE: <path d='M8 5h2l1 3-1.5 1a8 8 0 0 0 4.5 4.5L15 12l3 1v2a2 2 0 0 1-2 2A10 10 0 0 1 6 7a2 2 0 0 1 2-2z' fill='currentColor' />,
  EMAIL: <path d='M4 6.5h16v11H4zM4.5 7l7.5 6 7.5-6' {...stroke} />,
  WEBSITE: <path d='M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM4 12h16M12 4c-3 3-3 13 0 16m0-16c3 3 3 13 0 16' {...stroke} />,
  LINE: (
    <>
      <path d='M12 3.6c-5 0-9 3.2-9 7.2 0 3.6 3.2 6.6 7.5 7.1.3.1.7.2.8.5.1.2.1.6 0 .9l-.1.8c0 .2-.2.9.8.5 1-.4 5.5-3.2 7.5-5.5C20.9 13.6 21 12.3 21 10.8c0-4-4-7.2-9-7.2z' fill='#fff' />
      <text x='12' y='12.6' textAnchor='middle' fontSize='4.6' fontWeight='900' fontFamily='Arial, sans-serif' fill='#06C755'>
        LINE
      </text>
    </>
  ),
  WHATSAPP: (
    <>
      <path d='M12 3.2a8.8 8.8 0 0 0-7.6 13.2L3.2 20.8l4.5-1.2A8.8 8.8 0 1 0 12 3.2z' fill='none' stroke='#fff' strokeWidth='1.9' strokeLinejoin='round' />
      <path d='M9.1 7.9c.3-.2.7-.2.9.1l1 1.6c.2.3.1.6-.1.8l-.6.6c.5 1.2 1.4 2.1 2.6 2.6l.6-.6c.2-.2.6-.3.8-.1l1.6 1c.3.2.4.6.1.9l-.6.8c-.4.4-1 .6-1.6.4-2.6-.8-4.6-2.8-5.4-5.4-.2-.6 0-1.2.4-1.6z' fill='#fff' />
    </>
  ),
  MESSENGER: (
    <>
      <path d='M12 3C7 3 3.1 6.7 3.1 11.5c0 2.6 1.2 4.8 3 6.4V21l2.9-1.6c.9.3 1.9.4 3 .4 5 0 8.9-3.7 8.9-8.4S17 3 12 3z' fill='#fff' />
      <path d='M6.9 14.1l2.8-4.4c.4-.7 1.4-.9 2-.4l2.2 1.7 3.2-2.4c.3-.3.7.1.5.4l-2.8 4.4c-.4.7-1.4.9-2 .4l-2.2-1.7-3.2 2.4c-.3.3-.7-.1-.5-.4z' fill='#006AFF' />
    </>
  ),
  TELEGRAM: (
    <>
      <path d='M20.6 4.3L3.4 11c-1.1.4-1.1 1.1-.2 1.4l4.4 1.4 1.7 5.2c.2.6.5.7 1 .3l2.4-2 4.6 3.4c.8.5 1.4.2 1.6-.8l3-14c.3-1.3-.5-1.8-1.3-1.6z' fill='#fff' />
      <path d='M7.8 13.7l9.7-6.1-7.7 7.3-.3 3.5' fill='none' stroke='#229ED9' strokeWidth='1.1' strokeLinejoin='round' />
    </>
  ),
  FACEBOOK: <path d='M13.6 21v-7.6h2.6l.4-3h-3V8.6c0-.9.3-1.5 1.5-1.5h1.6V4.4c-.3 0-1.2-.1-2.3-.1-2.3 0-3.8 1.4-3.8 3.9v2.2H8v3h2.6V21z' fill='#fff' />,
  INSTAGRAM: (
    <>
      <rect x='3.8' y='3.8' width='16.4' height='16.4' rx='4.8' fill='none' stroke='#fff' strokeWidth='2' />
      <circle cx='12' cy='12' r='3.9' fill='none' stroke='#fff' strokeWidth='2' />
      <circle cx='16.9' cy='7.1' r='1.2' fill='#fff' />
    </>
  ),
  TIKTOK: <path d='M16.6 5.8a4.3 4.3 0 0 1-1-2.8h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.7a5.8 5.8 0 1 0 4.9 5.7V9.1a7.3 7.3 0 0 0 4.3 1.4V7.4a4.3 4.3 0 0 1-3.3-1.6z' fill='#fff' />,
}

export const ChannelTile: FC<{size?: number; tile: {background: string; color?: string; border?: string}; children: ReactNode}> = ({
  size = 36,
  tile,
  children,
}) => (
  <span
    aria-hidden='true'
    style={{
      width: size,
      height: size,
      borderRadius: Math.round(size / 4),
      background: tile.background,
      color: tile.color,
      border: tile.border,
      boxSizing: 'border-box',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      overflow: 'hidden',
    }}
  >
    {children}
  </span>
)

export const MINT_TILE = MINT
export const NEUTRAL_TILE = NEUTRAL

export const ChannelLogo: FC<{type: string; size?: number}> = ({type, size = 36}) => {
  const glyph = Math.round(size * 0.62)
  return (
    <ChannelTile
      size={size}
      tile={TILE[type] ?? NEUTRAL}
    >
      <svg
        viewBox='0 0 24 24'
        width={glyph}
        height={glyph}
        aria-hidden='true'
      >
        {GLYPHS[type] ?? GLYPHS.WEBSITE}
      </svg>
    </ChannelTile>
  )
}
